export default "__VITE_ASSET__B2U7rZ9v__"